import { Modal, RemoveScroll, ScrollArea, Text, Timeline } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { IOrder, IOrderPaymentLines } from '../../interfaces/Order';
import LoaderOverlay from '../../components/LoaderOverlay/LoaderOverlay';
import { formatMoneyString } from '../../utils/strings';
import moment from 'moment'; // Correct import
import { memo } from 'react';
import { ExtendedPaymentConfigEnum } from '../../enum/PaymentConfig';

export default memo(function OrderTimeLineModal({
  opened,
  close,
  title,
  order
}: {
  opened: boolean;
  close: () => void;
  title: string;
  order: IOrder | null;
}) {
  const { t } = useTranslation(['OrdersPage', 'FieldName']);

  const dates = [
    {
      date: order?.createdDate,
      label: t('OrdersPage:timelineModal.timeline.createdAt')
    },
    {
      date: order?.pickingUpDateTime,
      label: t('OrdersPage:timelineModal.timeline.pickingUpAt')
    },
    {
      date: order?.cleanedDateTime,
      label: t('OrdersPage:timelineModal.timeline.cleanedAt')
    },
    {
      date: order?.readyDateTime,
      label: t('OrdersPage:timelineModal.timeline.readyAt')
    },
    {
      date: order?.deliveringDateTime,
      label: t('OrdersPage:timelineModal.timeline.deliveringAt')
    },
    {
      date: order?.collectedDateTime,
      label: t('OrdersPage:timelineModal.timeline.collectedAt')
    },
    {
      date: order?.paidDateTime,
      label: t('OrdersPage:timelineModal.timeline.paidAt')
    },
    {
      date: order?.cancelledDateTime,
      label: t('OrdersPage:timelineModal.timeline.cancelledAt')
    },
    {
      date: order?.uncollectedDateTime,
      label: t('OrdersPage:timelineModal.timeline.uncollectedAt')
    },
    {
      date: order?.storeReceptionValidation?.validatedAt,
      label: t('OrdersPage:timelineModal.timeline.storeReceptionValidatedAt')
    },
    ...(order?.paymentLines.map((paymentLine: IOrderPaymentLines) => {
      return {
        label: `${t('OrdersPage:timelineModal.timeline.payment')} ${formatMoneyString(paymentLine.amountPaid)} (${t(
          `FieldName:paymentMethods.${
            ExtendedPaymentConfigEnum[
              paymentLine.paymentMethod.toUpperCase() as keyof typeof ExtendedPaymentConfigEnum
            ]
          }`
        )})`,
        date: paymentLine.paymentDate
      };
    }) || [])
  ]
    .filter((data) => data.date)
    .sort((left, right) => {
      return new Date(left.date).getTime() - new Date(right.date).getTime();
    });

  const timelineItems = dates.map((timelineItem: { date: Date; label: String }) => {
    return (
      <Timeline.Item
        key={`${timelineItem.date} + ${timelineItem.label}}`}
        title={timelineItem.label}>
        <Text c="dimmed" size="sm">
          {moment(timelineItem.date).format('DD/MM/YYYY hh:mm A')}
        </Text>
      </Timeline.Item>
    );
  });

  return (
    <Modal
      opened={opened}
      onClose={close}
      className={RemoveScroll.classNames.fullWidth}
      title={title}
      scrollAreaComponent={ScrollArea.Autosize}>
      {!order ? (
        <LoaderOverlay visible />
      ) : (
        <Timeline active={timelineItems.length} bulletSize={24} lineWidth={2}>
          {timelineItems}
        </Timeline>
      )}
    </Modal>
  );
});
